import React from 'react'
import FriendList from './FriendList';
import { friendElement,clerksElement,Breadcrumb } from './myFunctions';
import DescriptionLine from './DescriptionLine';
export default function MonthlyMeeting({oym,meeting,dropBreadcrumb,authenticated}) {
    console.log(meeting+" authenticated:"+authenticated);
    let monthlyMeetingObject = oym.objectRef(meeting);
    // console.log(monthlyMeetingObject);
    let clerkObject=oym.objectRef(monthlyMeetingObject.clerk);

    function dropClerkBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb(clerkObject.lastName,friendElement(oym,clerkObject,dropBreadcrumb)));
    }
    let memberList = (<></>);
    if (authenticated){
        memberList = (<>
            <h1>Members:</h1>
            <FriendList oym={oym} list={monthlyMeetingObject.members[1]} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} />
        </>);
    }
    let description = monthlyMeetingObject.directoryDiscription.text;
    while (description.endsWith(" ")||description.endsWith("\n")){
        description=description.substr(0,description.length-1);
    }
    let descriptionLines=description.split("\n");
    let descriptionElementLines = descriptionLines.map(line => {
        return DescriptionLine(line={line});
    })
    return (
        <div>
            <center>
                {monthlyMeetingObject.name}<br/>
                {clerksElement(monthlyMeetingObject,oym,dropBreadcrumb,authenticated)}<br/>
                {descriptionElementLines}
            </center>
            {memberList}
        </div>
    )
}
